import React from 'react';
import { PaginationItem, Pagination, PaginationProps } from '@material-ui/lab';
import { withStyles } from '@material-ui/core';
// eslint-disable-next-line import/named
import { variant } from 'src/materialConfig/customTypography';

const StylesPaginationItem = withStyles((theme) => ({
  root: {
    // height: '25px',
    // minWidth: '25px',
    // border: '1px solid #EDEDED',
    ...variant.smallText,
    padding: '8px 19px !important'
  },
  page: {
    border: '1px solid #D1D5DC !important',
    borderRadius: '4px !important',
  },
  selected: {
    backgroundColor: '#4A9EDB !important',
    color: 'white',
    borderColor: '#4A9EDB !important',
    padding: '10px !important',
    fontSize: '16px',
    margin: '0 8px !important'
  },
}))(PaginationItem);

export const BasePagination: React.FC<PaginationProps> = (props) => {
  return (
    <Pagination
      renderItem={(item) => <StylesPaginationItem {...item} />}
      {...props}
    />
  );
};
